var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 160,
    viewBox: "0 0 165 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.4219,
    cy: 80,
    r: 59.5,
    fill: "#EEF7FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9471,
    cy: 35.3748,
    r: 5.95,
    fill: "#EEF7FE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.872,
    cy: 114.213,
    r: 4.4625,
    fill: "#EEF7FE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2031,
    cy: 123.138,
    r: 7.4375,
    fill: "#EEF7FE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.797,
    cy: 54.7124,
    r: 7.4375,
    fill: "#EEF7FE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.666,
    cy: 28.6813,
    r: 5.20625,
    fill: "#EEF7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2256_26224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0145 32.3999C69.5669 32.3999 58.5559 38.5508 51.8552 47.979C49.6671 47.463 47.3852 47.1899 45.0395 47.1899C28.7029 47.1899 15.4595 60.4333 15.4595 76.7699C15.4595 93.1065 28.7029 106.35 45.0395 106.35L45.0698 106.35H118.955C118.966 106.35 118.978 106.35 118.989 106.35C133.284 106.35 144.872 94.7619 144.872 80.4674C144.872 66.1729 133.284 54.5849 118.989 54.5849C117.974 54.5849 116.972 54.6434 115.988 54.7571C110.322 41.6063 97.2432 32.3999 82.0145 32.3999Z",
    fill: "#EEF7FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.0395,
    cy: 76.7699,
    r: 29.58,
    fill: "url(#paint0_linear_2256_26224)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.0145,
    cy: 69.3749,
    r: 36.975,
    fill: "url(#paint1_linear_2256_26224)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.989,
    cy: 80.4675,
    r: 25.8825,
    fill: "url(#paint2_linear_2256_26224)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2256_26224)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.5967,
    y: 82.9751,
    width: 41.65,
    height: 41.65,
    rx: 20.825,
    fill: "#2C74D6",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2311 111.609L83.4565 107.835M85.4956 102.932C85.4956 106.766 82.3877 109.874 78.554 109.874C74.7202 109.874 71.6123 106.766 71.6123 102.932C71.6123 99.0986 74.7202 95.9907 78.554 95.9907C82.3877 95.9907 85.4956 99.0986 85.4956 102.932Z",
    stroke: "white",
    strokeWidth: 1.73542,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2256_26224",
    x: 0.584474,
    y: 32.3999,
    width: 159.163,
    height: 103.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.975,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2256_26224"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.95
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.975
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2256_26224"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.975,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_2256_26224"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.925
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2256_26224",
    result: "effect2_dropShadow_2256_26224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2256_26224",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2256_26224",
    x: 50.5967,
    y: 74.9751,
    width: 57.6499,
    height: 57.6499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2256_26224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2256_26224",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2256_26224",
    x1: 22.3263,
    y1: 57.226,
    x2: 74.6195,
    y2: 106.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2256_26224",
    x1: 53.623,
    y1: 44.945,
    x2: 118.99,
    y2: 106.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2256_26224",
    x1: 99.1154,
    y1: 63.3665,
    x2: 144.872,
    y2: 106.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default "data:image/svg+xml,%3csvg width='165' height='160' viewBox='0 0 165 160' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='79.4219' cy='80' r='59.5' fill='%23EEF7FE'/%3e %3ccircle cx='16.9471' cy='35.3748' r='5.95' fill='%23EEF7FE'/%3e %3ccircle cx='144.872' cy='114.213' r='4.4625' fill='%23EEF7FE'/%3e %3ccircle cx='16.2031' cy='123.138' r='7.4375' fill='%23EEF7FE'/%3e %3ccircle cx='153.797' cy='54.7124' r='7.4375' fill='%23EEF7FE'/%3e %3ccircle cx='139.666' cy='28.6813' r='5.20625' fill='%23EEF7FE'/%3e %3cg filter='url(%23filter0_dd_2256_26224)'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M82.0145 32.3999C69.5669 32.3999 58.5559 38.5508 51.8552 47.979C49.6671 47.463 47.3852 47.1899 45.0395 47.1899C28.7029 47.1899 15.4595 60.4333 15.4595 76.7699C15.4595 93.1065 28.7029 106.35 45.0395 106.35L45.0698 106.35H118.955C118.966 106.35 118.978 106.35 118.989 106.35C133.284 106.35 144.872 94.7619 144.872 80.4674C144.872 66.1729 133.284 54.5849 118.989 54.5849C117.974 54.5849 116.972 54.6434 115.988 54.7571C110.322 41.6063 97.2432 32.3999 82.0145 32.3999Z' fill='%23EEF7FE'/%3e %3ccircle cx='45.0395' cy='76.7699' r='29.58' fill='url(%23paint0_linear_2256_26224)'/%3e %3ccircle cx='82.0145' cy='69.3749' r='36.975' fill='url(%23paint1_linear_2256_26224)'/%3e %3ccircle cx='118.989' cy='80.4675' r='25.8825' fill='url(%23paint2_linear_2256_26224)'/%3e %3c/g%3e %3cg filter='url(%23filter1_b_2256_26224)'%3e %3crect x='58.5967' y='82.9751' width='41.65' height='41.65' rx='20.825' fill='%232C74D6' fill-opacity='0.4'/%3e %3cpath d='M87.2311 111.609L83.4565 107.835M85.4956 102.932C85.4956 106.766 82.3877 109.874 78.554 109.874C74.7202 109.874 71.6123 106.766 71.6123 102.932C71.6123 99.0986 74.7202 95.9907 78.554 95.9907C82.3877 95.9907 85.4956 99.0986 85.4956 102.932Z' stroke='white' stroke-width='1.73542' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/g%3e %3cdefs%3e %3cfilter id='filter0_dd_2256_26224' x='0.584474' y='32.3999' width='159.163' height='103.7' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeMorphology radius='2.975' operator='erode' in='SourceAlpha' result='effect1_dropShadow_2256_26224'/%3e %3cfeOffset dy='5.95'/%3e %3cfeGaussianBlur stdDeviation='2.975'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_2256_26224'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeMorphology radius='2.975' operator='erode' in='SourceAlpha' result='effect2_dropShadow_2256_26224'/%3e %3cfeOffset dy='14.875'/%3e %3cfeGaussianBlur stdDeviation='8.925'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0'/%3e %3cfeBlend mode='normal' in2='effect1_dropShadow_2256_26224' result='effect2_dropShadow_2256_26224'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_2256_26224' result='shape'/%3e %3c/filter%3e %3cfilter id='filter1_b_2256_26224' x='50.5967' y='74.9751' width='57.6499' height='57.6499' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeGaussianBlur in='BackgroundImage' stdDeviation='4'/%3e %3cfeComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_2256_26224'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur_2256_26224' result='shape'/%3e %3c/filter%3e %3clinearGradient id='paint0_linear_2256_26224' x1='22.3263' y1='57.226' x2='74.6195' y2='106.35' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint1_linear_2256_26224' x1='53.623' y1='44.945' x2='118.99' y2='106.35' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint2_linear_2256_26224' x1='99.1154' y1='63.3665' x2='144.872' y2='106.35' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };